import sharedProductPreferences from "@shared/productPreferences.cjs";

const {
  DEFAULT_PREFERENCE_WEIGHT,
  PRODUCT_PREFERENCE_OPTIONS,
  normalizeProductPreference: normalizeSharedProductPreference,
  normalizeProductPreferences: normalizeSharedProductPreferences,
} = sharedProductPreferences;

export { PRODUCT_PREFERENCE_OPTIONS };

export function normalizeProductPreference(value) {
  return normalizeSharedProductPreference(value);
}

export function normalizeProductPreferences(values) {
  return normalizeSharedProductPreferences(values);
}

export function buildPreferenceWeights(preferences, preferenceWeights) {
  const selected = normalizeProductPreferences(preferences);
  const weights =
    preferenceWeights && typeof preferenceWeights === "object"
      ? preferenceWeights
      : {};

  const normalizedWeights = Object.entries(weights).reduce(
    (result, [key, value]) => {
      result[normalizeProductPreference(key)] = value;
      return result;
    },
    {}
  );

  return selected.reduce((result, preference) => {
    result[preference] = Math.max(
      1,
      Math.min(
        5,
        Number(normalizedWeights[preference]) || DEFAULT_PREFERENCE_WEIGHT
      )
    );
    return result;
  }, {});
}
